// extracted by mini-css-extract-plugin
module.exports = {"title":"imprint_title__ajfBe","section":"imprint_section__3z7eN","header":"imprint_header__CvYkt","contact":"imprint_contact__2xTqO","disclaimer":"imprint_disclaimer__2U2YH"};